import React from 'react';

import CircleCheckIcon from '../../assets/svg_components/CircleCheckIcon';

import PaymentSuccessfulStyle from './PaymentSuccessful.module.scss';
import PaymentSuccessfulV2 from './PaymentSuccessfulV2';

const PaymentSuccessful = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const getQueryAmount = queryParams?.get('amount');
  const transactionId = queryParams?.get('transactionId');

  if (transactionId) {
    return <PaymentSuccessfulV2 />;
  }
  return (
    <div className={PaymentSuccessfulStyle?.wrapper}>
      <div className={PaymentSuccessfulStyle?.wrapper__Container}>
        <div className={PaymentSuccessfulStyle?.wrapper__icon}>
          <CircleCheckIcon fillColor="#5941A9" width="100px" height="100px" />
        </div>
        <div className={PaymentSuccessfulStyle?.wrapper__title}>Payment Successful</div>
        <div className={PaymentSuccessfulStyle?.wrapper__subtitle}>
          Your transaction has been completed successfully.
        </div>
        <div className={PaymentSuccessfulStyle?.wrapper__amount}>
          Amount paid: ${getQueryAmount?.split('?').join(' ')}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessful;
